import { useEffect, type ReactNode } from "react";

interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

export default function Modal({ open, title, onClose, children }: ModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭弹窗"
        className="absolute inset-0 h-full w-full cursor-pointer bg-background-950/70 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-md animate-fade-up rounded-lg border border-background-200/70 bg-background-100 p-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-heading text-lg font-semibold text-foreground-50">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-200 hover:text-foreground-100"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="mt-4 text-sm leading-relaxed text-foreground-400">{children}</div>
      </div>
    </div>
  );
}